'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './logout.routes';

export class LogoutComponent {
  constructor($window, authService) {
    authService.destroySession();
    $window.location.href = '/';
  }
}

LogoutComponent.$inject = ['$window', 'authService'];

export default angular.module('syncplicityLoginApp.logout', [uiRouter])
  .config(routes)
  .component('logout', {
    template: '',
    controller: LogoutComponent,
    controllerAs: 'logoutCtrl'
  })
  .name;


// WEBPACK FOOTER //
// ./client/app/logout/logout.component.js